import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcNotificationHandler } from './rpc-notification-handler';
import { RpcNotification, RpcNotificationKey } from './rpc-notification-model';

/**
 * Rpc notification subject interface.
 */
export interface RpcNotificationSubject extends Subject<DeferredData<RpcNotification, void>> {}

/**
 * The class to implement Rpc notification with Subject server.
 */
export class RpcNotificationSubjectServer extends RpcSubjectServer<RpcNotification, void> implements RpcNotificationHandler {
    /**
     * Initializes a new instance of the RpcNotificationSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcNotificationKey.command);
    }

    /**
     * The handler to respond a request for Rpc notification call.
     *
     * @param data The notification object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcNotification): Promise<void> {
        return this.processNextForSubject(RpcNotificationKey.command, data);
    }
}
